<template>
    <article :id="project.id" class="card scroll-mt-24 overflow-hidden">
        <div class="p-7 sm:p-10">
            <div class="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
                <div>
                    <h2 class="font-display text-[32px] font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[38px]">
                        {{ project.name }}
                    </h2>
                    <p v-if="project.subtitle" class="mt-2 text-[16px] text-accent">{{ project.subtitle }}</p>
                </div>

                <div v-if="project.links" class="flex flex-wrap gap-2">
                    <a v-for="(link, i) in project.links" :key="link.href" :href="link.href" target="_blank"
                        rel="noopener noreferrer" :class="i === 0 ? 'btn-primary' : 'btn-ghost'">
                        {{ link.label }}
                        <i class="fa-solid fa-arrow-up-right-from-square text-[11px]"></i>
                    </a>
                </div>
            </div>

            <div class="mt-7 max-w-[760px] space-y-4 prose-body">
                <p v-for="(paragraph, i) in project.description" :key="i">{{ paragraph }}</p>
            </div>

            <ul v-if="project.stack" class="mt-8 flex flex-wrap gap-2">
                <li v-for="tech in project.stack" :key="tech" class="chip">{{ tech }}</li>
            </ul>
        </div>

        <div class="bg-surface-2 p-5 sm:p-10">
            <div :class="['grid gap-5', project.images.length > 1 ? 'md:grid-cols-2' : 'mx-auto max-w-[880px]']">
                <img v-for="image in project.images" :key="image.src" :src="image.src" :alt="image.alt"
                    :width="image.width" :height="image.height" loading="lazy" decoding="async"
                    class="h-auto w-full rounded-2xl bg-surface shadow-soft" />
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        project: { type: Object, required: true }
    }
};
</script>
